<template>
  <a
    class="googleplay__link"
    :class="{ 'googleplay__link--disabled': disabled }"
    target="_blank"
    rel="noopener"
    :href="href"
    @click="$emit('close')">
    <google-play-icon
      class="googleplay__img"
      :class="{ 'googleplay__img--big': isBig }" />
  </a>
</template>

<script>
import { mapState } from 'vuex';
import { getAdvertisingParamsFromSession } from 'Root/helpers/handleAdvertisingParams';

import GooglePlayIcon from 'Components/ui/AppMarkets/GooglePlayIcon.vue';

const SERVE_USER_BUTTON = '748934177449077486';
// SKY-4050: пока оставляю такую же, в будущем поменяется, когда получим инфу от маркетинга
const SERVE_GUEST_BUTTON = '1181293224954772730';

const SERVE_USER_FOOTER = '388646204004635603';
const SERVE_GUEST_FOOTER = '821005091942268924';

export default {
  name: 'GoogleplayButton',
  components: { GooglePlayIcon },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    isBig: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Тип события для UTM
     */
    type: {
      type: String,
      default: 'button',
      validator: (value) => ['button', 'footer'].includes(value),
    },
  },

  data() {
    return {
      isSsr: true,
    };
  },

  computed: {
    ...mapState(['user']),

    href() {
      let SERVE;

      if (this.type === 'button') {
        SERVE = this.user ? SERVE_USER_BUTTON : SERVE_GUEST_BUTTON;
      } else {
        SERVE = this.user ? SERVE_USER_FOOTER : SERVE_GUEST_FOOTER;
      }

      const baseLink = `https://redirect.appmetrica.yandex.com/serve/${SERVE}`;
      let routePath;

      if (this.$route.path.includes('/client/orders/')) {
        routePath = '/client/orders/';
      } else {
        routePath = this.$route.path;
      }

      if (this.isSsr) {
        return `${baseLink}?placement=${routePath}`;
      }

      const UTM = getAdvertisingParamsFromSession();

      const utmParams = [
        'source',
        'medium',
        'campaign',
        'term',
        'placement',
        'content',
      ];

      const utmParts = [];

      utmParams.forEach((param) => {
        if (param in UTM) {
          utmParts.push(`utm_${param}=${UTM[param]}`);
        }
      });

      if (!utmParts.length) {
        utmParts.push('utm_source=skycoach.gg', 'utm_medium=website');
      }

      return `${baseLink}?${utmParts.join('&')}&placement=${routePath}`;
    },
  },

  beforeMount() {
    if (typeof window !== 'undefined') {
      this.isSsr = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.googleplay__link {
  background: var(--background, $color--basic-black);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 112px;
  border-radius: 4px;
  transition: var(--transition-color-bg);
}

.googleplay__link--disabled {
  cursor: default;
  opacity: .5;
  pointer-events: none;
}

.googleplay__img {
  color: var(--color, $color--basic-white);
  width: 112px;
  height: 40px;
}

.googleplay__img--big {
  width: 148px;
  height: 50px;
}
</style>
